import React, { useState } from 'react';
import { IoCopyOutline, IoCheckmarkOutline } from 'react-icons/io5';
import styled from 'styled-components';
import { contentColumnPadding } from '../../theme/constants';

interface Props {
  content: string;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

const UserMessage: React.FC<Props> = ({ content, scrollRef }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // clipboard API unavailable
    }
  };

  return (
    <Wrapper ref={scrollRef}>
      <BubbleRow>
        <CopyButton
          onClick={handleCopy}
          title={copied ? 'Copied!' : 'Copy message'}
          aria-label={copied ? 'Copied' : 'Copy message'}
          $copied={copied}
        >
          {copied ? <IoCheckmarkOutline size={13} /> : <IoCopyOutline size={13} />}
        </CopyButton>
        <Bubble>{content}</Bubble>
      </BubbleRow>
    </Wrapper>
  );
};

export default UserMessage;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 0 4px;
`;

const BubbleRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  max-width: 80%;
`;

const CopyButton = styled.button<{ $copied: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme, $copied }) => ($copied ? theme.av2.primary : theme.av2.textMuted)};
  opacity: 0;
  transition: opacity 0.12s ease, color 0.12s ease, background 0.12s ease;
  margin-bottom: 2px;

  ${BubbleRow}:hover & {
    opacity: 1;
  }

  &:hover {
    background: ${({ theme }) => theme.av2.hoverBg};
    color: ${({ theme, $copied }) => ($copied ? theme.av2.primary : theme.av2.textSecondary)};
  }
`;

const Bubble = styled.div`
  background: ${({ theme }) => theme.av2.userBubble};
  color: ${({ theme }) => theme.av2.textOnAccent};
  border-radius: 18px 18px 4px 18px;
  padding: 12px 18px;
  font-size: 16px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
`;
